import React from "react";

export default function OrderModePopup({ onSelect }) {
  return (
    <div className="popup-overlay">
      <div className="popup-box">
        <h2>Choose Order Mode</h2>
        <p>Please select how you want to place your order:</p>

        <div className="popup-actions">
          <button onClick={() => onSelect("online")}>Order Online</button>
          <button onClick={() => onSelect("shop")}>Order In Shop</button>
        </div>
      </div>
    </div>
  );
}
